import { faPlus } from '@fortawesome/free-solid-svg-icons';
import * as React from 'react';
import { connect } from 'react-redux';
import { EventType } from 'stageclip-common';

import { DataRequestActionTypes } from '../../constants/actionTypes';
import { FormId } from '../../constants/formId';
import FormModal from '../modal/formModal';

import { BaseEventForm, mapBaseEventDispatchToProps, mapBaseEventStateToProps } from './baseEventForm';

class CreateEventForm extends BaseEventForm {
  constructor(props: any) {
    super(props);
    this.validateForm = this.validateForm.bind(this);
  }

  protected loggedInRender() {
    return (
      <FormModal
        formId={FormId.EventForm}
        formTitle="Add event"
        submitActionType={DataRequestActionTypes.CreateEventRequested}
        validateForm={this.validateForm}
        buttonIcon={faPlus}
        showSendAnotherCheckbox
        initialValues={{ type: EventType.Graduation, vgUploadDurationLimit: 10 }}
      >
        {this.renderFields()}
      </FormModal>
    );
  }
}

export default connect(mapBaseEventStateToProps, mapBaseEventDispatchToProps)(CreateEventForm);
